import { render } from "./SampleList.vue?vue&type=template&id=f5cf163c&scoped=true"
import script from "./SampleList.vue?vue&type=script&lang=js"
export * from "./SampleList.vue?vue&type=script&lang=js"

import "./SampleList.vue?vue&type=style&index=0&id=f5cf163c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5cf163c"]])

export default __exports__